import { Box, Typography, Checkbox, Radio } from '@mui/material';
import MachineStatus from '../machines/machineStatus';
import Skeleton from '@mui/material/Skeleton';
import Iconify from '../Iconify';

const AddMachinesConcerneeListViewData = ({ chooseSingleMachine, machine, handleMachineClick, regions, columnWidth, selectedMachines, allMachinesSelected }) => {

    if (!machine) {
        return (
            <Box className='table_row'>
                <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
                {regions.length > 1 && <Box sx={{ color: '#414040', minWidth: columnWidth.region }}><Skeleton variant="text" width="100%" /></Box>}
                <Box sx={{ color: '#414040', minWidth: columnWidth.site }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.pole }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.metier }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.status }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.marque }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#EA5E00', width: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
            </Box>
        );
    }

    return (
        <Box className='table_row'>
            <Box className='tableBodyCell' sx={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#EA5E00', minWidth: columnWidth.name, maxWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
                {chooseSingleMachine ?
                    <Radio
                        sx={{
                            '&.Mui-checked': {
                                color: '#EA5E00',
                            },
                        }}
                        checked={selectedMachines.includes(machine.id)}
                        onChange={() => handleMachineClick(machine.id)}
                    />
                    :
                    <Checkbox
                        sx={{
                            '&.Mui-checked': {
                                color: '#EA5E00',
                            },
                        }}
                        checked={selectedMachines.includes(machine.id) || allMachinesSelected} onChange={() => handleMachineClick(machine.id)}
                    />
                }
                <Typography className='tableBodyTypography'>{machine?.name}</Typography>
            </Box>
            {regions.length > 1 &&
                <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.region, maxWidth: columnWidth.region }}>
                    <Typography className='tableBodyTypography'> {machine?.region?.name}</Typography>
                </Box>
            }
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.site, maxWidth: columnWidth.site }}>
                <Typography className='tableBodyTypography'>{machine?.site?.name}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.pole, maxWidth: columnWidth.pole }}>
                <Typography className='tableBodyTypography'>{machine?.pole?.name}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.metier, maxWidth: columnWidth.metier }}>
                <Typography className='tableBodyTypography'>{machine?.machine_metier?.map((metier) => metier?.metier?.name).join(" - ") || 'N/A'}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.status, maxWidth: columnWidth.status }}>
                <MachineStatus status={machine?.status} />
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.marque, maxWidth: columnWidth.marque }}>
                <Typography className='tableBodyTypography'>{machine?.marque?.name || 'N/A'}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
        </Box>
    );
};

export default AddMachinesConcerneeListViewData;